export default "__VITE_ASSET__Cz3xy0tY__"